import { SamplePack } from '@arpeggi/shared'
import { Badge, Box } from '@arpeggi/ui'
import moment from 'moment'
import { ComponentProps, FC } from 'react'
import { usePriceCard } from '../hooks'
import { CollapsibleCard, ExternalLink } from '../primitives'
import { Countdown } from './Countdown'
import { MintCollectionButton } from './MintCollectionButton'

const COMMERCIAL_LICENSE_LINK = '/legal/sound-pack-license-commercial'

const LicenseBox = () => (
  <Box row justifyCenter alignCenter css={{ text: '12', marginTop: '14px' }}>
    {`By clicking Collect, I agree to the `}
    <ExternalLink
      href={COMMERCIAL_LICENSE_LINK}
      target="_blank"
      css={{ marginLeft: '3px' }}
    >{`Artist Sound Pack License`}</ExternalLink>
  </Box>
)

const CollapsibleRow: FC<{ title: string; description: string }> = ({ title, description }) => (
  <CollapsibleCard.Row>
    <CollapsibleCard.Text>{title}</CollapsibleCard.Text>
    <CollapsibleCard.Text>{description}</CollapsibleCard.Text>
  </CollapsibleCard.Row>
)

interface PriceCardProps {
  sp: SamplePack
  isPresale?: boolean
}

export const PriceCard: FC<PriceCardProps & ComponentProps<typeof CollapsibleCard.Root>> = ({
  sp,
  isPresale,
  ...props
}) => {
  const {
    activationText,
    mintHasExpired,
    totalMinted,
    volume,
    ethPrice,
    subtitle,
    countdownDate,
    showCommercialLicenseCopy,
    endIsSoon,
    saleLive
  } = usePriceCard(sp, isPresale)
  const headerText = isPresale ? 'Presale' : 'Public Sale'
  const isExternal = sp?.edition?.isExternal
  const soldOut = totalMinted === volume
  const showCountdown = !mintHasExpired && !soldOut && (!saleLive || endIsSoon)
  return (
    <CollapsibleCard.Root isCollapsed={isPresale} {...props}>
      <CollapsibleCard.Trigger>
        <CollapsibleCard.Header>
          <CollapsibleCard.Title>{headerText}</CollapsibleCard.Title>
          <Box row>
            <CollapsibleCard.Subtitle>
              {subtitle === 'Live' ? <Badge type="live">{subtitle}</Badge> : subtitle}
            </CollapsibleCard.Subtitle>
            <CollapsibleCard.Arrow />
          </Box>
        </CollapsibleCard.Header>
      </CollapsibleCard.Trigger>

      <CollapsibleCard.Content>
        <CollapsibleCard.Content>
          {showCountdown && <Countdown until={moment(countdownDate)} />}
          <CollapsibleCard.Text muted padded>
            {(!saleLive || endIsSoon) && activationText}
          </CollapsibleCard.Text>
          <CollapsibleRow title={'PRICE'} description={ethPrice} />
          {!isExternal && (
            <CollapsibleRow title={'COLLECTED'} description={`${totalMinted} / ${volume}`} />
          )}
          {isExternal && <CollapsibleRow title={'VOLUME'} description={`${volume}`} />}
          <MintCollectionButton sp={sp} isPresale={isPresale} />
          {showCommercialLicenseCopy && <LicenseBox />}
        </CollapsibleCard.Content>
      </CollapsibleCard.Content>
    </CollapsibleCard.Root>
  )
}
